import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import Field from 'brandComponents/Form/Subcomponents/Field';
import PasswordFieldForm from 'brandComponents/Form/Subcomponents/PasswordField';

import {IPasswordFieldProps} from './IPasswordField';

import styles from './PasswordField.module.scss';

const PasswordField = ({classNamesCntr, passwordValidation, ...props}: IPasswordFieldProps) => {
	const intl = useIntl();
	const {managerRepository} = useGeneralProvider();
	const passwordConfig = useMemo(() => managerRepository.getConfigurationsMgr().get('passwordConfig'), []);

	const validation = passwordValidation?.map((item) => {
		return {
			rule: item.rule,
			errorMessage: intl.formatMessage(item.errorMessage, passwordConfig)
		};
	});

	return (
		<Field
			classNamesCntr={cn(styles['password-field'], classNamesCntr)}
			component={PasswordFieldForm}
			validation={validation}
			{...props}
		/>
	);
};

export default PasswordField;
